import { useTranslation } from 'react-i18next'

/** The prototype's `.sim-badge` (MS-820): a simulation must never read as a
 * statement of fact, so it is badged in the simulation's own amber — the
 * `.badge` geometry (2px 10px, 12px radius, 11px/600) with amber text, wash
 * and border, the text lightened in dark mode. */
export function SimulationBadge({ className = '' }: Readonly<{ className?: string }>) {
  const { t } = useTranslation()
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-xl text-[11px] font-semibold whitespace-nowrap normal-case tracking-normal text-[var(--sim-badge-fg)] bg-[var(--sim-badge-bg)] border border-[var(--sim-badge-border)] ${className}`}
    >
      {t('simulation.badge')}
    </span>
  )
}
